import script from "./UsersListView.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersListView.vue?vue&type=script&setup=true&lang=js"

import "./UsersListView.vue?vue&type=style&index=0&id=983e3d42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-983e3d42"]])

export default __exports__